module.exports = __webpack_public_path__ + "static/media/mosque.43b81b74.webp";